import React from "react";
import "./stylee.css";
const Startup_card = () => {
  return (
    <>
      <div class="slider owl-carousel">
        <div class="card">
          <div class="img">
            <img
              src="https://images.unsplash.com/photo-1551818255-e6e10975bc17?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8ZXZlbnRzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
              alt=""
            />
          </div>
          <div class="content">
            <div class="title">Briana Tozour</div>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit
              modi dolorem quis quae animi nihil minus sed unde voluptas cumque.
            </p>
            <div class="btn">
              <center>
                {" "}
                <button>Read more</button>{" "}
              </center>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="img">
            <img
              src="https://images.unsplash.com/photo-1556125574-d7f27ec36a06?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8ZXZlbnRzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
              alt=""
            />
          </div>
          <div class="content">
            <div class="title">Pricilla Preez</div>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit
              modi dolorem quis quae animi nihil minus sed unde voluptas cumque.
            </p>
            <div class="btn">
              <center>
                {" "}
                <button>Read more</button>{" "}
              </center>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="img">
            <img
              src="https://images.unsplash.com/photo-1587407627257-27b7127c868c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fGV2ZW50c3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
              alt=""
            />
          </div>
          <div class="content">
            <div class="title">Eliana Maia</div>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit
              modi dolorem quis quae animi nihil minus sed unde voluptas cumque.
            </p>
            <div class="btn">
              <center>
                {" "}
                <button>Read more</button>{" "}
              </center>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Startup_card;
